//REV-21369 — die Typen des Beleg-Viewers (ADR-0021 E5/E6).

/** Ein Rechteck, normiert auf [0,1] der UNGEDREHTEN Seite, Ursprung oben links, vier Dezimalen. */
export interface PdfRect {
    x: number;
    y: number;
    w: number;
    h: number;
}

/**
 * Wer die Markierung gesetzt hat. `ai` kommt erst mit REV-22164 (Fundstelle am Befund) — der Typ
 * und das Attribut stehen schon jetzt da, damit der zweite Autor eine DATEN-Änderung ist und keine
 * Ansichts-Änderung (Freigabe 30.09.2026: KI-Markierungen sind unterscheidbar).
 */
export type PdfHighlightAuthor = 'human' | 'ai';

/** Eine Markierung, wie der Viewer sie zeichnet. Ein Eintrag je Notiz, beliebig viele Rechtecke. */
export interface PdfHighlight {
    /** Die Notiz-Id — sie kommt über `highlightSelected` zurück. */
    id: string;
    /** 1-basiert. Eine Seite ausserhalb des Dokuments wird nicht gezeichnet, nicht als Fehler gemeldet. */
    page: number;
    rects: PdfRect[];
    author: PdfHighlightAuthor;
}

/**
 * Eine neue Markierung, bevor sie eine Notiz ist. Der Viewer meldet sie; Notiz, Beleg-Bezug und
 * Speichern sind Sache des Wirts.
 */
export interface PdfAnnotationDraft {
    page: number;
    rects: PdfRect[];
    /** Der markierte Text — `null` bei einer Flächen-Markierung (Scan ohne Textschicht). */
    snippet: string | null;
}

/** Text auswählen oder eine Fläche aufziehen. */
export type PdfMarkMode = 'text' | 'area';
